/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Steps } from '@/types';
import { AssistantContext } from '@/contexts';
import {
  TYPE_REGISTRE_MARIAGE,
  URL_SOUS_TYPES_ACTE_MARIAGE,
} from '@/constants';

import InformationsActe from './InformationsActe';
import InformationsContratMariage from './InformationsContratMariage';
import InformationsEvenementMariage from './InformationsEvenementMariage';
import InformationsOfficier from './InformationsOfficier';

/**
 * Étape 1 « Acte » de l'acte de mariage : les informations de l'acte (réutilisées,
 * paramétrées sur les sous-types de mariage) complétées de l'officier d'état
 * civil, puis la célébration et le contrat de mariage.
 *
 * Les deux conjoints et leurs parents ont chacun leur étape — six en tout, la
 * plus longue des quatre types d'acte.
 *
 * L'officier est rendu DANS le bloc de l'acte et non à côté : c'est un
 * sous-bloc, comme la maquette le présente.
 */
const StepActeMariage = () => {
  const { data, onChange, errors } = React.useContext(AssistantContext);

  /** Tranche d'erreurs propre à cette étape (clés = `name` des champs) */
  const errorsStep = errors?.[Steps.Acte] ?? {};

  return (
    <div
      className="assistant-step-acte-mariage"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.25em',
        width: '100%',
      }}
    >
      <InformationsActe
        data={data}
        errors={errorsStep}
        onChange={onChange}
        urlSousTypesActe={URL_SOUS_TYPES_ACTE_MARIAGE}
        typeRegistre={TYPE_REGISTRE_MARIAGE}
        labelSousTypeActe="Sous type de mariage"
      >
        <InformationsOfficier
          data={data}
          errors={errorsStep}
          onChange={onChange}
        />
      </InformationsActe>
      <InformationsEvenementMariage
        data={data}
        errors={errorsStep}
        onChange={onChange}
      />
      <InformationsContratMariage
        data={data}
        errors={errorsStep}
        onChange={onChange}
      />
    </div>
  );
};

export default StepActeMariage;
